import React, { Component } from "react";
import { connect } from "react-redux";
import {
    clockIn,
    clockOut,
    get as loadClock,
    getEmployees as loadEmployees,
    getEvents as loadEvents,
    saveEvents
} from "../../reducer/actions";
import { Button, Dimmer, Form, Header, Icon, Loader, Modal, Segment, Table } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import { getActivities, getEmployees, getEvents, isLoading } from "../../reducer";
import WarehouseSelect from "../../components/WarehouseSelect";
import ActivitySelect from "../../components/ActivitySelect";

import BigCalendar from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import moment from "moment";

import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = BigCalendar.momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(BigCalendar, { backend: false });


const inlineStyle = {
    modal: {
        marginTop: "0px !important",
        marginLeft: "auto",
        marginRight: "auto"
    }
};

export const activityColors = {
    1: '#247BA0',
    2: '#70C1B3',
    3: '#B2DBBF',
    4: '#6CC551',
    5: '#487B72',
    6: '#174F66',
    7: '#FF1654',
    8: '#FFAAC0',
};


class Schedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: 'week',
            activity_id: null,
            employee_id: 1,
            warehouse_id: null,
            loaded_warehouse_id: null,
            minTime: moment({
                hour: 6,
                minute: 0
            })
                .toDate(),
            dayChosen: new Date(),
            events: [],
            minDate: moment()
                .subtract(1, "month")
                .startOf("month")
                .toDate(),
            maxDate: moment()
                .add(1, "month")
                .endOf("month")
                .toDate(),
            addModalOpen: false,
            detailModalOpen: false,
            selectedEvent: null,
            newEvent: null,
            loaded: false
        };


        this.moveEvent = this.moveEvent.bind(this);
        this.resizeEvent = this.resizeEvent.bind(this);
        this.newEvent = this.newEvent.bind(this);
    }

    reloadEvents() {
        return new Promise((resolve)=>{
            this.props.loadEvents(this.state.warehouse_id, moment(this.state.minDate)
                .format("X"), moment(this.state.maxDate)
                .format("X"))
                .then((events) => {
                    this.setState({
                        loaded_warehouse_id: this.state.warehouse_id,
                        loaded: true,
                        events: events.map((event) => {

                            event.start = moment(event.start)
                                .toDate();
                            event.end = moment(event.end)
                                .toDate();
                            event.title = this.constructor.getEventTitle(event,this.props.activities,this.props.employees);
                            event.allDay = event.allDay === 1;

                            return event;
                        })
                    });
                    resolve();
                });
        });

    }


    moveEvent({ event, start, end, isAllDay: droppedOnAllDaySlot }) {
        const { events } = this.state;

        const idx = events.indexOf(event);
        let allDay = event.allDay;

        if (!event.allDay && droppedOnAllDaySlot) {
            allDay = true;
        } else if (event.allDay && !droppedOnAllDaySlot) {
            allDay = false;
        }

        const updatedEvent = {
            ...event,
            start,
            end,
            allDay
        };

        const nextEvents = [...events];
        nextEvents.splice(idx, 1, updatedEvent);

        this.setState({
            events: nextEvents,
        });

        // alert(`${event.title} was dropped onto ${updatedEvent.start}`)
    }

    resizeEvent({ event, start, end }) {
        console.log("in resize event", event);
        const { events } = this.state;

        const nextEvents = events.map(existingEvent => {
            return existingEvent.id === event.id
                ? {
                    ...existingEvent,
                    start,
                    end
                }
                : existingEvent;
        });

        this.setState({
            events: nextEvents,
        });

        //alert(`${event.title} was resized to ${start}-${end}`)
    }

    newEvent(event) {
        this.setState({
            newEvent: event,
            addModalOpen: true
        });
    }

    saveEvents() {
        return new Promise((resolve)=>{
            let events = this.state.events.map((event) => {
                let eventCopy = { ...event };
                eventCopy.start = moment(event.start)
                    .format("YYYY-MM-DD HH:mm:ss");
                eventCopy.end = moment(event.end)
                    .format("YYYY-MM-DD HH:mm:ss");
                return eventCopy;
            });
            this.props.saveEvents(this.state.loaded_warehouse_id, events)
                .then(() => {
                    this.reloadEvents().then(()=>{resolve()});
                });
        })

    }


    componentWillMount() {

        this.props.loadClock()
            .then(() => {
                this.props.loadEmployees();
            });

    }

    deleteEvent(pEvent) {
        const r = window.confirm("Would you like to remove this event?");
        if (r === true) {

            this.setState((prevState, props) => {
                const events = [...prevState.events];
                events.map((event) => {
                    if (event.id === pEvent.id) {
                        event.delete = true;
                    }
                    return event;
                });
                return { events };
            });
        }
    }

    onSelectEvent(pEvent) {

        this.setState({
            selectedEvent: pEvent,
            detailModalOpen: true
        });

    }

    render() {


        return (
            <div>
                <Dimmer active={this.props.loading}>
                    <Loader>Loading</Loader>
                </Dimmer>
                <Segment stacked>

                    <WarehouseSelect
                        value={this.state.warehouse_id}
                        onChange={(warehouse_id) => {
                            this.setState({ warehouse_id });
                        }}
                    />
                    {this.state.loaded ? <Modal
                        style={inlineStyle.modal}
                        trigger={<Button color='green' inverted>
                            <Icon name='search'/> Load
                        </Button>}
                        header='Änderungen speichern?'
                        content='Alle ungespeicherten Änderungen gehen verloren'
                        actions={[{
                            key: "load",
                            content: "Trotzdem fortfahren",
                            negative: true,
                            onClick: ()=>{
                                this.reloadEvents();
                            }
                        }, {
                            key: "save",
                            content: "Änderungen speichern & neu laden",
                            positive: true,
                            onClick: ()=>{
                                this.saveEvents()
                            }
                        }]}
                    /> : <div>{this.state.warehouse_id && <Button color='green' onClick={
                        () => {
                            this.reloadEvents();
                        }
                    } inverted>
                        <Icon name='search'/> Laden
                    </Button>}</div>}


                    {this.state.loaded &&
                    <Button color='green' onClick={
                        () => {
                            this.saveEvents();
                        }


                    } inverted>
                        <Icon name='checkmark'/> Speichern
                    </Button>
                    }
                </Segment>
                {this.state.loaded && <Segment>


                    <div style={{ minHeight: "100vh" }}>

                        <DragAndDropCalendar
                            selectable
                            style={{ minHeight: "100vh" }}
                            localizer={localizer}
                            defaultView={"week"}
                            view={this.state.view}
                            onView={(view)=>{this.setState({view})}}
                            min={this.state.minTime}
                            events={this.state.events}
                            onEventDrop={this.moveEvent}
                            resizable
                            date={this.state.dayChosen}
                            onEventResize={this.resizeEvent}
                            onSelectSlot={this.newEvent}
                            defaultDate={new Date()}
                            onSelectEvent={event => this.onSelectEvent(event)}
                            eventPropGetter={(event) => {
                                if (event.delete) {
                                    return { style: { display: "none !important" } };
                                }
                                if(event.activity_id in activityColors){
                                    return {style: { backgroundColor: activityColors[event.activity_id]}}
                                }
                            }}
                            onNavigate={(focusDate, flipUnit, prevOrNext) => {

                                let date = moment(focusDate);

                                if (date.diff(this.state.minDate) > 0 && date.diff(this.state.maxDate) < 0) {
                                    this.setState({
                                        dayChosen: date.toDate()
                                    });
                                }


                            }}
                            messages={{
                                allDay: "ganzer Tag",
                                previous: "Vorherige",
                                next: "Nächste",
                                today: "Heute",
                                month: "Monat",
                                week: "Woche",
                                day: "Tag",
                                agenda: "Agenda",
                                date: "Datum",
                                time: "Stunde",
                                event: "Eintrag", // Or anything you want
                                showMore: total => `+ ${total} weitere Einträge`
                            }}
                        />
                    </div>
                </Segment>
                }
                <Modal
                    style={inlineStyle.modal}
                    open={this.state.addModalOpen}
                    onClose={() => {
                        this.setState({ addModalOpen: false });
                    }}
                    size='small'
                >
                    <Header icon='browser' content='New Event'/>
                    <Modal.Content>
                        <ActivitySelect
                            value={this.state.newEvent && this.state.newEvent.activity_id}
                            onChange={(value) => {
                                this.setState(({ newEvent }) => ({
                                    newEvent: {
                                        ...newEvent,
                                        activity_id: value
                                    }
                                }));
                            }}
                        />
                        <Form.Select
                            fluid
                            search selection
                            label={"Mitarbeiter"}
                            options={this.props.employees.map((employee) => (
                                {
                                    key: employee.id,
                                    value: employee.id,
                                    text: employee.name
                                }
                            ))}
                            onChange={(e, { value }) => {
                                this.setState(({ newEvent }) => ({
                                    newEvent: {
                                        ...newEvent,
                                        employee_id: value
                                    }
                                }));
                            }}
                            value={this.state.newEvent && this.state.newEvent.employee_id}
                            required
                        />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={
                            () => {
                                let idList = this.state.events.map(a => a.id);
                                let newId = Number.isInteger(Math.max(...idList)) ? Math.max(...idList) + 1 : Math.random()
                                    .toString(36)
                                    .substr(2, 9);
                                let hour = {
                                    id: "new" + newId,
                                    title: this.constructor.getEventTitle(this.state.newEvent,this.props.activities,this.props.employees),

                                    allDay: this.state.newEvent.slots.length === 1,
                                    start: this.state.newEvent.start,
                                    end: this.state.newEvent.end,
                                    activity_id: this.state.newEvent.activity_id,
                                    warehouse_id: this.state.loaded_warehouse_id,
                                    employee_id: this.state.newEvent.employee_id
                                };
                                this.setState({
                                    events: this.state.events.concat([hour]),
                                    addModalOpen: false
                                });


                            }


                        } inverted>
                            <Icon name='checkmark'/> Speichhern
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    style={inlineStyle.modal}
                    open={this.state.detailModalOpen}
                    onClose={() => {
                        this.setState({ detailModalOpen: false });
                    }}
                    size='small'
                >
                    <Header icon='browser' content='Eintrag bearbeiten'/>
                    <Modal.Content>
                        <ActivitySelect
                            value={this.state.selectedEvent && this.state.selectedEvent.activity_id}
                            onChange={(value) => {
                                console.log(value);
                                console.log(this.state);
                                this.setState(({ selectedEvent }) => (
                                    {
                                        selectedEvent: {
                                            ...selectedEvent,
                                            activity_id: value
                                        }
                                    }
                                ));
                            }}
                        />
                        <Form.Select
                            fluid
                            search selection
                            label={"Mitarbeiter"}
                            options={this.props.employees.map((employee) => (
                                {
                                    key: employee.id,
                                    value: employee.id,
                                    text: employee.name
                                }
                            ))}
                            onChange={(e, { value }) => {
                                this.setState(({ selectedEvent }) => ({
                                    selectedEvent: {
                                        ...selectedEvent,
                                        employee_id: value
                                    }
                                }));
                            }}
                            value={this.state.selectedEvent && this.state.selectedEvent.employee_id}
                            required
                        />

                        {this.state.selectedEvent && this.state.selectedEvent.creator_id && <p>Bearbeitet durch: {this.props.employees.reduce((a,b)=>{if(b.id === this.state.selectedEvent.creator_id){return b.name}return a},'')}</p>}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={
                            () => {

                                this.setState((state) => {

                                    for (let eventId in state.events) {
                                        if (state.events[eventId].id !== state.selectedEvent.id) {
                                            continue;
                                        }
                                        state.events[eventId] = state.selectedEvent;
                                        state.events[eventId].title = this.constructor.getEventTitle(state.selectedEvent,this.props.activities,this.props.employees);
                                    }

                                    return {
                                        ...state,
                                        events: state.events,
                                        detailModalOpen: false
                                    };
                                });


                            }


                        } inverted>
                            <Icon name='checkmark'/> Speichern
                        </Button>
                        <Button color='red' onClick={
                            () => {

                                this.deleteEvent(this.state.selectedEvent);
                                this.setState({
                                    detailModalOpen: false,
                                    selectedEvent: null
                                });


                            }


                        } inverted>
                            <Icon name='checkmark'/> Eintrag löschen
                        </Button>
                    </Modal.Actions>
                </Modal>

                {this.state.loaded && this.state.events.length > 0 && <Segment>
                    <Header>Zusammenfassung:</Header>
                    {this.constructor.getSummary(this.state.dayChosen,this.state.view,this.state.events,this.props.activities,this.props.employees)}
                </Segment>}
            </div>

        );

    }


    static getSummary(currentDate, view, events, activities, employees){


        if(view === 'agenda'){
            return <div> </div>;
        }

        // save for references
        events = JSON.parse(JSON.stringify(events));

        let summaryStart = moment(currentDate);
        let summaryEnd = moment(currentDate);

        switch(view){
            case 'week':
                summaryStart = summaryStart.startOf('week');
                summaryEnd = summaryEnd.endOf('week');
                break;
            case 'month':
                summaryStart = summaryStart.startOf('month');
                summaryEnd = summaryEnd.endOf('month');
                break;

            case 'day':
                summaryStart = summaryStart.startOf('day');
                summaryEnd = summaryEnd.endOf('day');
                break;

            default:
                summaryStart = summaryStart.startOf('month');
                summaryEnd = summaryEnd.endOf('month');
                break;
        }

        events = events.map((event)=>{
            if(moment(event.start).diff(summaryStart) <= 0 && moment(event.end).diff(summaryStart) > 1){
                event.start = summaryStart.toDate();
            }
            if(moment(event.start).diff(summaryStart) >= 0 && moment(event.end).diff(summaryEnd) > 1){
                event.end = summaryEnd.toDate();
            }
            return event;
        });

        events = events.filter((event)=>{

            if(moment(event.end).diff(summaryStart) <= 0 ){
                return false;
            }

            if(moment(event.start).diff(summaryEnd) > 1){
                return false;
            }
            return true;
        });

        const groupBy = function(xs, key) {
            return xs.reduce(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };

        let byEmployee = groupBy(events,'employee_id');
        let prepared = [];

        for(let employee_id in byEmployee){
            let byActivity = groupBy(byEmployee[employee_id],'activity_id');
            let employee = {activities: []};
            for(let activity_id in byActivity){
                let activity = {};
                activity.duration = byActivity[activity_id].reduce((a,b)=>{if(!b.start || !b.end || !!b.allDay){return a;}return a + moment(b.end).diff(moment(b.start),'minutes')},0);
                activity.days = byActivity[activity_id].reduce((a,b)=>{if(!b.start || !b.end || !b.allDay){return a;}return a + Math.ceil(moment(b.end).diff(moment(b.start),'days', true))},0);
                activity.activityName = activities.reduce((a,b)=>{if(b.id === Number.parseInt(activity_id,10)){return b.displayName}return a},'');
                employee.activities.push(activity);
            }
            employee.employeeName = employees.reduce((a,b)=>{if(b.id === Number.parseInt(employee_id,10)){return b.name}return a},'');
            prepared.push(employee);
        }


        return <div>{prepared.map((employee)=>
            <div key={employee.employeeName}>
                <Header as='h2' style={{margin:'10px'}}>{employee.employeeName}</Header>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Aktivität</Table.HeaderCell>
                            <Table.HeaderCell>Stunden</Table.HeaderCell>
                            <Table.HeaderCell>ganze Tage</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>

                {employee.activities.map((activity)=>{
                    return <Table.Row key={activity.activityName}>
                        <Table.Cell>{activity.activityName}</Table.Cell>
                        <Table.Cell>{activity.duration/60}</Table.Cell>
                        <Table.Cell>{activity.days}</Table.Cell>
                    </Table.Row>
                })}

                    </Table.Body>

                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell>Total</Table.HeaderCell>
                            <Table.HeaderCell>{employee.activities.reduce((a,b)=>a+b.duration,0)/60}</Table.HeaderCell>
                            <Table.HeaderCell>{employee.activities.reduce((a,b)=>a+b.days,0)}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>

            </div>
        )}</div>
    }

    static getEventTitle(event,activities,employees) {
        return employees.reduce((a, b) => {
            if (b.id === event.employee_id) {
                return b.name;
            }
            return a;
        }, "") + " - " + activities.reduce((a, b) => {
            if (b.id === event.activity_id) {
                return b.displayName;
            }
            return a;
        }, "");
    }

}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    employees: getEmployees(state),
    activities: getActivities(state),
    events: getEvents(state),
    loading: isLoading(state)
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    };
}

const mapDispatchToProps = (dispatch) => {
    return ({
        loadClock: () => (dispatch(loadClock())),
        clockIn: (body) => (dispatch(clockIn(body))),
        clockOut: () => (dispatch(clockOut())),
        loadEmployees: () => (dispatch(loadEmployees())),
        loadEvents: (warehouse, start, end) => (dispatch(loadEvents(warehouse, start, end))),
        saveEvents: (warehouse, events) => (dispatch(saveEvents(warehouse, events))),
    });
};


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Schedule);



// WEBPACK FOOTER //
// ./src/scenes/Clock/scenes/Schedule/index.js